import getBaseUrl from './getBaseUrl';
import axios from '../axiosConfig';

const options = { credentials: 'include' };

const getUrl = (path) => `${getBaseUrl()}account${path[0] !== '/' ? '/' : ''}${path}`;

const AccountSvc = {
  getAccount: () => axios.get(getUrl('/customer'), options),
  getUsers: () => axios.get(getUrl('/customer/users?includeDetails=true'), options),
  getInvitations: () => axios.get(getUrl('/customer/invitations'), options),
  postInvitation: (data) => axios.post(getUrl('/customer/invitations?sendToTarget=true'), data, options),
  revokeInvitation: (email) =>
    axios.delete(
      getUrl(`/customer/invitations?target=${encodeURIComponent(email)}&targetType=EMAIL&hardDelete=false`),
      options
    ),
  deleteInvitation: (email) =>
    axios.delete(
      getUrl(`/customer/invitations?target=${encodeURIComponent(email)}&targetType=EMAIL&hardDelete=true`),
      options
    ),
  deactivateUser: (userId) =>
    axios.put(getUrl(`/customer/users/${userId}`), { status: 'DISABLED', userUuid: userId }, options),
  reactivateUser: (userId) =>
    axios.put(getUrl(`/customer/users/${userId}`), { status: 'ENABLED', userUuid: userId }, options),
  deleteUser: (userId) => axios.delete(getUrl(`/customer/users/${userId}`), options),
  getRole: (userId) => axios.get(getUrl(`/customer/users/${userId}/roles`), options),
  setRole: (userId, role) => axios.put(getUrl(`/customer/users/${userId}/roles`), [{ roleId: role }], options),
};

export default AccountSvc;
